// Reusable supplier dashboard primitives — same structure will be reused for
// Phase 4 (Payment Gateways) and Phase 5 (Users & Roles).
import React from 'react';

export const STATUS_CHIP = {
  Active:    'bg-green-100 text-green-800 border-green-300',
  Pending:   'bg-amber-100 text-amber-800 border-amber-300',
  Suspended: 'bg-gray-200 text-gray-700 border-gray-300',
  Draft:     'bg-slate-100 text-slate-600 border-slate-300',
};

export const HEALTH_CHIP = {
  healthy: { dot: 'bg-green-500',  text: 'text-green-700',  label: 'Healthy' },
  slow:    { dot: 'bg-amber-500',  text: 'text-amber-700',  label: 'Slow'    },
  failed:  { dot: 'bg-red-500',    text: 'text-red-700',    label: 'Failed'  },
  unknown: { dot: 'bg-gray-400',   text: 'text-gray-500',   label: 'Untested' },
};

export const StatCard = ({ label, value, accent = 'red', sub, testId }) => {
  const accentMap = {
    red:    'from-red-500/10 to-red-500/0   text-red-600',
    green:  'from-green-500/10 to-green-500/0 text-green-600',
    amber:  'from-amber-500/10 to-amber-500/0 text-amber-600',
    gray:   'from-gray-500/10 to-gray-500/0  text-gray-700',
    blue:   'from-blue-500/10 to-blue-500/0  text-blue-600',
  };
  return (
    <div data-testid={testId} className={`rounded-xl border border-gray-200 dark:border-gray-800 bg-gradient-to-br ${accentMap[accent] || accentMap.red} p-4 transition-shadow hover:shadow-md`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">{label}</p>
      <p className="text-3xl font-bold mt-1 text-gray-900 dark:text-white">{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${STATUS_CHIP[status] || STATUS_CHIP.Pending}`}>
    {status}
  </span>
);

export const HealthBadge = ({ state, latency }) => {
  const cfg = HEALTH_CHIP[state] || HEALTH_CHIP.unknown;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${cfg.text}`}>
      <span className={`h-2 w-2 rounded-full ${cfg.dot}`} />
      {cfg.label}
      {latency ? <span className="text-gray-400 font-normal">· {latency}ms</span> : null}
    </span>
  );
};

export const EmptyState = ({ title, sub, action }) => (
  <div className="border border-dashed border-gray-300 dark:border-gray-700 rounded-xl py-12 text-center">
    <p className="font-semibold text-gray-700 dark:text-gray-200">{title}</p>
    {sub && <p className="text-sm text-gray-500 mt-1">{sub}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
